// extracted by mini-css-extract-plugin
module.exports = {"social":"Share_social__3VXEn","socialIcon":"Share_socialIcon__3zKC4"};